import { Component, OnInit, HostListener } from '@angular/core';
import { SessionService } from '../../shared/services/session.service';
import { CalendarService } from '../../shared/services/calendar.service';
import { Log } from '../../shared/utils/log';
import { Utils } from '../../shared/utils/utils';
import { TimeDay } from '../../shared/models/schedule/time-day.model';
import { Slot } from '../../shared/models/schedule/slot.model';
import { Location } from '../../shared/models/location.model';
import * as moment from 'moment-timezone';

enum ScreenMode {
    desktop = 1,
    tablet,
    phone
}

@Component({
    templateUrl: 'select-time.component.html',
    standalone: false
})
export class SelectTimeComponent implements OnInit {

    public dates:Array<TimeDay> = new Array<TimeDay>();
    protected numberOfColumns:number = 5;
    public focusDate:Date = null;
    public location: Location;
    public focusMonth: string = '';

    private _windowWidth: number;
    private _mobileMaxCols: number = 1;
    private _tabletMaxCols: number = 3;
    private _desktopMaxCols: number = 5;
    private _totalCols:number = 1;
    private _screenMode:number = 0;
    private moment: any;

    public get totalCols():number {
        return this._totalCols;
    }

    constructor(private _sessionService:SessionService,
                private _calendarService:CalendarService) {
                    this.moment = moment;
                }

    ngOnInit() {
        // this.setTimeZone();
        this.focusDate = this._sessionService.appointmentDate;
        this.location = this._sessionService.location;
        this.setFocusedMonth();
        this.onResize(); // do check of initial size
        Utils.scrollUp();
    }

    public onTimeSelected(event:Slot) {
        Log.message('onTimeSelected ' + event);
        this._sessionService.appointmentSlot = event;
        this._sessionService.appointmentTime = event.date;
    }

    public prevDay() {
        this.focusDate = Utils.getPastDay(this.focusDate);
        this.renderCols();
        this.setFocusedMonth();
    }
    public nextDay() {
        this.focusDate = Utils.getFutureDay(this.focusDate);
        this.renderCols();
        this.setFocusedMonth();
    }

    @HostListener('window:resize', ['$event'])
    protected onResize(event?: any) {

        if(!event) {
            this._windowWidth = window.innerWidth;
        } else {
            this._windowWidth = event.target.innerWidth;
        }

        // desktop
        if (this._windowWidth > 992) {
            this._totalCols = this._desktopMaxCols;
            if(this._screenMode !== ScreenMode.desktop) {
                this.renderCols();
            }
            this._screenMode = ScreenMode.desktop;
        }

        // tablets
        if (this._windowWidth <= 992 && this._windowWidth >= 768) {
            this._totalCols = this._tabletMaxCols;
            if(this._screenMode !== ScreenMode.tablet) {
                this.renderCols();
            }
            this._screenMode = ScreenMode.tablet;
        }

        // phones
        if (this._windowWidth < 768) {
            this._totalCols = this._mobileMaxCols;
            if(this._screenMode !== ScreenMode.phone) {
                this.renderCols();
            }
            this._screenMode = ScreenMode.phone;
        }

    }

    private setFocusedMonth() {
        this.focusMonth = 'GENERAL_REUSABLE.MONTHS.';
        switch (this.focusDate.getMonth() + 1) {
            case 1:
                this.focusMonth += 'JANUARY';
                break;
            case 2:
                this.focusMonth += 'FEBRUARY';
                break;
            case 3:
                this.focusMonth += 'MARCH';
                break;
            case 4:
                this.focusMonth += 'APRIL';
                break;
            case 5:
                this.focusMonth += 'MAY';
                break;
            case 6:
                this.focusMonth += 'JUNE';
                break;
            case 7:
                this.focusMonth += 'JULY';
                break;
            case 8:
                this.focusMonth += 'AUGUST';
                break;
            case 9:
                this.focusMonth += 'SEPTEMBER';
                break;
            case 10:
                this.focusMonth += 'OCTOBER';
                break;
            case 11:
                this.focusMonth += 'NOVEMBER';
                break;
            case 12:
                this.focusMonth += 'DECEMBER';
                break;
        }
    }

    private renderCols() {
        if(this._totalCols > 2) {
            this.dates = this._calendarService.getTimeDatesArrayPyramid(this.focusDate, this._totalCols);
        } else {
            let timeDay:TimeDay = new TimeDay(this.focusDate, true);
            this.dates = new Array<TimeDay>(timeDay);
        }
    }

    /**
     * TODO: verify server-size timezone data
     */
    // private setTimeZone() {
    //     let hourOffset = this.focusDate.getTimezoneOffset() / 60;
    //     if(hourOffset > 3 && hourOffset < 8) {
    //         this.timeZoneOffset = 'SCHEDULE_INTERVIEW.TIME.ZONE.'+hourOffset;
    //     } else {
    //         this.timeZoneOffset = 'SCHEDULE_INTERVIEW.TIME.ZONE.OTHER';
    //     }
    // }

}
